// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/entrance-bg-lg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvopmmeHnbdXZfTDmEG9 {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: cover;
}
.w3YJdSZD9yQ8aKC4vsyh {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  font-weight: bold;
  line-height: 28px;
  color: #fff;
}
.w3YJdSZD9yQ8aKC4vsyh a {
  display: inline-block;
  margin-left: 10px;
  width: 80px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  font-weight: bold;
  color: #037C4B;
}
.CbpXjI95ID2KwgPsDQWD {
  flex: auto;
}
.XUB9cUquNTfUP2ZTdgSv {
  width: 560px;
  padding: 50px 80px;
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.21);
  border-radius: 10px;
  margin: 10px auto;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/EntranceLayout/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,2EAAA;EACA,sBAAA;AAAF;AAGA;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AADF;AALA;EASI,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AADJ;AAKA;EACE,UAAA;AAHF;AAOA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,iBAAA;AALF","sourcesContent":["\n.container {\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  height: 100vh;\n  background: url('../../assets/entrance-bg-lg.png') no-repeat center center;\n  background-size: cover;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  padding: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  color: #fff;\n\n  a {\n    display: inline-block;\n    margin-left: 10px;\n    width: 80px;\n    height: 32px;\n    line-height: 32px;\n    text-align: center;\n    background: #ffffff;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n    border-radius: 5px;\n    font-weight: bold;\n    color: #037C4B;\n  }\n}\n\n.content {\n  flex: auto;\n  \n}\n\n.form {\n  width: 560px;\n  padding: 50px 80px;\n  background: #ffffff;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.21);\n  border-radius: 10px;\n  margin: 10px auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EvopmmeHnbdXZfTDmEG9`,
	"header": `w3YJdSZD9yQ8aKC4vsyh`,
	"content": `CbpXjI95ID2KwgPsDQWD`,
	"form": `XUB9cUquNTfUP2ZTdgSv`
};
export default ___CSS_LOADER_EXPORT___;
